import React from "react";
import cn from "classnames";
import styles from "./Steps.module.sass";
import ScrollParallax from "../../../components/ScrollParallax";

const items = [
  {
    title: "Formulaire simples et adaptés",
    color: "#39B7CD",
    images: "/images/content/download.svg",
    content:
      "L'étudiant et l'entreprise répondent à des formulaires simples et adaptés.",
  },
  {
    title: "Génération automatique des documents",
    color: "#39B7CD",
    images: "/images/content/whistle.svg",
    content:
      "Les cerfa et la convention sont générés automatiquement et certifiés.",
  },
  {
    title: "Signature et envoi sécurisé",
    color: "#39B7CD",
    images: "/images/content/whistle.svg",
    content:
      "Les documents sont envoyés et signés en numérique.",
  },
  {
    title: "Envoi direct à tous les OPCO",
    color: "#39B7CD",
    images: "/images/content/medal.svg",
    content:
      "Les documents sont envoyés directement à l'opco concerné.",
  },
  {
    title: "Suivi et facturation",
    color: "#39B7CD",
    images: "/images/content/stopwatch.svg",
    content:
      "Le suivi des dossiers et des contrats d'alternance est centralisé et sécurisé.",
  },
];

const Steps = ({ scrollToRef }) => {
  return (
    <div className={cn("section", styles.section)} ref={scrollToRef}>
      <div className={cn("container", styles.container)}>
        <div className={styles.head}>
          <h2 className={cn("h2", styles.title)}>Étape par étape</h2>
          <div className={styles.info}>
            Simplifiez la gestion de vos contrats d'alternance avec notre processus automatisé en 5 étapes.
          </div>
        </div>
        <div className={styles.stepsContainer}>
          <div className={styles.stepsLine}>
            {items.map((x, index) => (
              <React.Fragment key={index}>
                <ScrollParallax className={styles.stepItem}>
                  <div
                    className={styles.stepIcon}
                    style={{ backgroundColor: x.color }}
                  >
                    <img src={x.images} alt={`Étape ${index + 1}`} />
                  </div>
                  <div className={styles.stepNumber}>Étape {index + 1}</div>
                  <div className={styles.stepTitle}>{x.title}</div>
                  <div className={styles.stepContent}>{x.content}</div>
                </ScrollParallax>
                {index < items.length - 1 && (
                  <div className={styles.stepConnector}>
                    <div className={styles.dashedLine}></div>
                  </div>
                )}
              </React.Fragment>
            ))}
          </div>
        </div>
      </div>
    </div>
  );
};

export default Steps;
